export default function Footer() {
  return (
    <footer className="bg-black text-gray-400 py-12 text-center">
      <p>© 2026 Simuwerk India • All Rights Reserved</p>
      <p className="mt-3 text-sm">
        Advanced Simulation Solutions for Global Industries
      </p>
    </footer>
  );
}
